import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { OwlOptions } from 'ngx-owl-carousel-o/lib/models/owl-options.model';
import { PlatformService } from '@shared/services/platform.service';
import { PromotionImageResponse } from '@medindex-webapi';
import { isAbsoluteLink } from '@shared/utils/isAbsoluteLink';

import bannerPlaceholderSrc from '!!file-loader!./assets/banner-placeholder.png';

@Component({
  selector: 'app-promotions-slider',
  templateUrl: './promotions-slider.component.html',
  styleUrls: ['./promotions-slider.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PromotionsSliderComponent {
  constructor(public platform: PlatformService) {}

  @Input()
  public sliders: PromotionImageResponse[] | undefined = [];

  public promotionsSliderOptions: OwlOptions = {
    items: 1.25,
    margin: 10,
    loop: true,
    nav: true,
    navText: [''],
    mouseDrag: true,
    autoplay: true,
    autoplayHoverPause: true,
    startPosition: 0,
  };

  bannerPlaceholderSrc = bannerPlaceholderSrc;

  onImgLoad(event: Event): void {
    const element: HTMLImageElement = event.target as HTMLImageElement;
    element.style.visibility = 'unset';
  }

  onImgError(event: ErrorEvent): void {
    const element: HTMLImageElement = event.target as HTMLImageElement;
    element.src = this.bannerPlaceholderSrc;
  }

  protected isAbsoluteLink = isAbsoluteLink;
}
